export function getContent(url, callBack, target) {
  fetch(url, {
    headers: {
      "Accept": "application/json",
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.json())
    .then(result => { callBack(result, target); })
}
